export function relativeRo(timestampMs: number, nowMs = Date.now()): string {
  const delta = Math.max(0, nowMs - timestampMs);
  const min = Math.floor(delta / 60_000);
  if (min < 1) return "acum";
  if (min < 60) return `acum ${min} min`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `acum ${hr} h`;
  const days = Math.floor(hr / 24);
  return `acum ${days} z`;
}

export function isSameMinuteGroup(a: number, b: number) {
  return Math.abs(a - b) < 5 * 60 * 1000;
}
